import React from 'react';
import FilterAndShort from '../filterAndShort/FilterAndShort';
const ShortingAndFilter = () => {
    return (
        <>
            <div className="mb-3" style={{height: "1px",background: "#707070"}}></div>
            <div className="row mb-5 gap-2 gap-lg-0">
                <div className="col-12 col-lg-8 col-md-6"><span className="sub_pop text-center text-lg-start">Subscription by Most Popular</span></div>
                <div className="col-12 col-lg-4 d-flex justify-content-start justify-content-lg-end align-items-center gap-4">
                    <FilterAndShort></FilterAndShort>
                </div>
            </div>
        </>
    );
};

export default ShortingAndFilter;